import { render, staticRenderFns } from "./PreBuildingModal.vue?vue&type=template&id=60752d11&"
import script from "./PreBuildingModal.vue?vue&type=script&lang=js&"
export * from "./PreBuildingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60752d11')) {
      api.createRecord('60752d11', component.options)
    } else {
      api.reload('60752d11', component.options)
    }
    module.hot.accept("./PreBuildingModal.vue?vue&type=template&id=60752d11&", function () {
      api.rerender('60752d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/PreBuildingModal.vue"
export default component.exports